module.exports = __webpack_public_path__ + "static/img/pie-left.eb4fee4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pie-left.png
// module id = sYMH
// module chunks = 10